import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import loginModule from './modules/login';
import bedrijfModule from './modules/bedrijf';
import accountModule from './modules/account';
import afdelingModule from './modules/afdeling';
import afdelingteeltModule from './modules/afdelingteelt';

Vue.use(Vuex);

// Do not enable strict mode when deploying for production!!!

export default new Vuex.Store({
    strict: true,
    modules: {
        loginModule,
        bedrijfModule,
        accountModule,
        afdelingModule,
        afdelingteeltModule,
    },
    plugins: [createPersistedState()],
});



// WEBPACK FOOTER //
// ./src/store/index.js